import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  state() {
    return {
      users: [],
      usersCount: 0,
      pageLimit: 0,
      userInfo: {},
      domainSkills: null,
      dialoutNum: "",
      userLoginStatus: null,
      domainRanges: null,
      domainUsers: null,
      skillInfo: null,
      schedules: [],
      waitClasses: [],
      welcomeMessage: null,
      allDomains: null,
      domainInfo: null,
      domainsNames: null,
      domainsShortCodes: null,
      domainsRanges: null,
      domainsNotDefaultPermissions: null,
      domainDefaultUserPermissions: null,
      domainDefaultPhoneInfo: null,
      domainsSkills: null,
      domainUsernames: null,
      callReasons: [],
      ivrRating: null,
      omniRating: null,
      kpis: [],
      csatQuestions: [],
      statusReasons: [],
      // User limits state
      userLimits: {
        counts: { agents: 0, reporters: 0, admins: 0 },
        limits: { agents: 0, reporters: 0, admins: 0 },
        isAgentLimit: false,
        isReporterLimit: false,
        isAdminLimit: false,
        noAgent: false,
        noReporter: false,
        noAdmin: false,
        inLimits: false,
        limitReached: false,
      },
    };
  },
  mutations,
  actions,
  getters,
};
